import axios from "axios";
import { environment } from "../../../environments/environment";
import { IAddress } from "../../../models/IAddress";
import { ADDRESS_URL } from "../../../constants/backendUrl";
export class AddressService {
  private static URL: any = environment.partnerApiUrl;

  public static getAddressByPartnerId = (partnerid: number) => {
    let UserURL: string = `${this.URL}/${ADDRESS_URL.getPartnerAddressByPartnerId}/${partnerid}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(UserURL, config);
  };

  public static addAddress(address: any) {
    let UserURL: string = `${this.URL}/${ADDRESS_URL.addPartnerAddress}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.post<any>(UserURL, address, config);
  }

  public static updateAddress(address: any) {
    let UserURL: string = `${this.URL}/${ADDRESS_URL.updatePartnerAddress}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.put<any>(UserURL, address, config);
  }
}
